import styled from 'styled-components';

export const OptionsBottomBarWrapper = styled.div``;
